import { render, staticRenderFns } from "./UtilityBlock.vue?vue&type=template&id=de196db0&scoped=true&"
import script from "./UtilityBlock.vue?vue&type=script&lang=js&"
export * from "./UtilityBlock.vue?vue&type=script&lang=js&"
import style0 from "./UtilityBlock.vue?vue&type=style&index=0&id=de196db0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de196db0",
  null
  
)

export default component.exports